import { UnsupportedOperationError } from "@archipad-js/core/error";

import { ConfigOperator } from "../config-operator";

export const NewObject = new ConfigOperator("NewObject", () => null);

export const Update = new ConfigOperator("Update", () => {
    throw new UnsupportedOperationError("Not implemented");
});
